module.exports = __webpack_public_path__ + "img/light.9123133a.jpg";